import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { FileText, Loader2 } from 'lucide-react'
import { hasModule } from '../../access/modules.js'
import { useCurrentUser } from '../../../hooks/useCurrentUser.js'
import { useCreateQuote, useQuoteOffers } from '../../../hooks/useQuotes.js'

/**
 * Bouton « Faire le devis » d'une offre (espace de travail Serge) : ouvre le devis déjà commencé
 * pour cette offre, ou en crée un à partir de ses spécifications et de son prospect.
 */
export default function QuoteFromOfferButton({ projectId }) {
  const navigate = useNavigate()
  const { user } = useCurrentUser()
  const allowed = hasModule(user, 'contracts')
  const { data } = useQuoteOffers(allowed)
  const createQuote = useCreateQuote()
  if (!allowed || !projectId) return null

  const existing = data?.offers?.find((o) => String(o.id) === String(projectId))?.quoteId

  const handleClick = () => {
    if (existing) {
      navigate(`/dashboard/contrats/devis/${existing}`)
      return
    }
    createQuote.mutate(
      { sergeProjectId: String(projectId) },
      {
        onSuccess: (quote) => navigate(`/dashboard/contrats/devis/${quote.id}`),
        onError: (error) => toast.error(error?.response?.data?.error || 'Création du devis impossible'),
      }
    )
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={createQuote.isPending}
      className="inline-flex items-center gap-2 bg-primary px-4 py-2 text-sm font-semibold text-white disabled:opacity-50"
    >
      {createQuote.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4" />}
      {existing ? 'Voir le devis' : 'Faire le devis'}
    </button>
  )
}
